import React from "react";
import {useState, useEffect, useLayoutEffect} from 'react';

import './App.css';
import './output.css';

const About = () => {
  const [changeClass, setChangeClass] = useState(false);

  var about_text = 
  `
  Hi  there!  Thank  u  for  visiting  my  website:D
  Here  is  摆烂Jo,  an  amateur  programmer.
  This  website  was  established  on  November  24,  2025.
  `
  
  setTimeout(() => {
    setChangeClass(true);
  }, 100);

  return(
    <div style={{minHeight:'calc(100lvh - 4rem)', minWidth:'60rem'}} className="z-10 bg-amber-50 w-full text-center place-content-center grid">
      <div style={{transition:'opacity 1s ease'}} className={!changeClass ? "opacity-0" : "opacity-100"}>
        <div style={{whiteSpace:'pre-wrap'}}>
          <div style={{fontFamily:'Hello Headline, lyt', fontSize: '50px'}}>
            {about_text}
          </div>
        </div>
      </div>      
    </div> 
  )
}

export default About;